
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "27",
    "viewBox": "0 0 26 27"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill": "#000",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "d": "M12.998 0c-5.736 0-10.4 4.843-10.4 10.8 0 5.602 6.809 16.2 10.4 16.2s10.4-10.598 10.4-16.2c0-5.957-4.664-10.8-10.4-10.8zm0 24.3c-1.804-.27-7.8-8.758-7.8-13.5 0-4.472 3.494-8.1 7.8-8.1 4.306 0 7.8 3.628 7.8 8.1 0 4.742-5.996 13.23-7.8 13.5zm0-10.8c1.436 0 2.6-1.209 2.6-2.7s-1.164-2.7-2.6-2.7c-1.436 0-2.6 1.209-2.6 2.7s1.164 2.7 2.6 2.7z",
                            "transform": "translate(-721 -709) translate(355 692) translate(338) translate(28 17)"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  